import type { AnimalTypeLabel } from './index';

export type LimitedField =
  | 'nameTag'
  | 'name'
  | 'tag'
  | 'rfidTag'
  | 'registrationNumber';

// Legacy column sizes (#39985). The API rejects longer values; checking them
// here keeps the error inline on the field instead of after a round trip.
const MAX_LENGTHS: Record<
  AnimalTypeLabel,
  Partial<Record<LimitedField, number>>
> = {
  Donor: {
    nameTag: 43,
    name: 50,
    tag: 10,
    rfidTag: 15,
    registrationNumber: 20,
  },
  Recipient: { tag: 10, rfidTag: 15, registrationNumber: 45 },
  Calf: { name: 50, tag: 10, rfidTag: 12, registrationNumber: 45 },
  'LOPU Donor': {},
};

export const maxFieldLength = (
  type: AnimalTypeLabel | undefined,
  field: LimitedField,
): number | undefined => (type ? MAX_LENGTHS[type][field] : undefined);

export const tooLongMessage = (max: number) =>
  `Too long. Use ${max} characters or fewer.`;

/** The too-long message for a value, or null if it fits. Values are trimmed first, as they are when sent. */
export const fieldLengthError = (
  type: AnimalTypeLabel | undefined,
  field: LimitedField,
  value: string | null | undefined,
): string | null => {
  const max = maxFieldLength(type, field);
  return max !== undefined && (value?.trim().length ?? 0) > max
    ? tooLongMessage(max)
    : null;
};
